// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
// These are for non-departmentalized locations
export const VoicemailService = {
    // Returns list of voicemails for the give location with applied filters passed (pagination, mailbox, callername,
    // read status etc.) in the request. Note: this API only accepts one location in the request. Tailor-made for
    // desktop client/app
    ListVoicemails(fn, req) {
        return fn(`/phone-exp/voicemail?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SetVoicemailViewStatus(fn, req) {
        try {
            fm.validateUrlParam(req["voicemailId"], "voicemailId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/voicemail/view/${req["voicemailId"]}`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteVoicemail(fn, req) {
        try {
            fm.validateUrlParam(req["voicemailId"], "voicemailId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/voicemail/${req["voicemailId"]}?${fm.renderURLSearchParams(req, ["voicemailId"])}`, { method: "DELETE" });
    },
    // Forward a voicemail message from one mailbox to another
    ForwardVoicemailMessage(fn, req) {
        return fn(`/phone-exp/voicemail/forward_voicemail_message`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetVoicemailFilePath(fn, req) {
        try {
            fm.validateUrlParam(req["voicemailId"], "voicemailId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/voicemail/file/${req["voicemailId"]}?${fm.renderURLSearchParams(req, ["voicemailId"])}`, { method: "GET" });
    },
    // Returns number of messages in each voicemail box for the given location
    CountVoicemailsForLocation(fn, req) {
        return fn(`/phone-exp/voicemail/count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // Returns number of messages in the given voicemail box id
    CountVoicemails(fn, req) {
        try {
            fm.validateUrlParam(req["mailboxId"], "mailboxId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/voicemail/${req["mailboxId"]}/count?${fm.renderURLSearchParams(req, ["mailboxId"])}`, { method: "GET" });
    },
    //Returns list of voicemails boxes for the given location ids with its type, department info (if available)
    ListVoicemailBox(fn, req) {
        return fn(`/phone-exp/voicemail/mailboxes?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // Voicemail Override APIs
    UpdateVMO(fn, req) {
        return fn(`/phone-exp/voicemail/v1/update-vmo`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ReadVMO(fn, req) {
        return fn(`/phone-exp/voicemail/v1/read-vmo?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // Get voicemail by message Id
    GetVoicemail(fn, req) {
        try {
            fm.validateUrlParam(req["messageId"], "messageId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/voicemail/message/${req["messageId"]}?${fm.renderURLSearchParams(req, ["messageId"])}`, { method: "GET" });
    },
};
